<script lang="ts">
	import juricekBanner from "../assets/images/juricek-proud-on-values.png?webp&w=1519&imagetools";
	import StaticPicture from "../components/Picture/StaticPicture.svelte";
	import { flyInOnScroll } from "../utils/flyInOnScroll";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { nbspifyHtml } from "../../../core/utils/nbspifyHtml.js";

	export let isSmall = false;
	export let headline: string;
	export let description: string;
	export let about: string;
	const ceoName = "Pavel Juříček";
	/* eslint-disable svelte/no-at-html-tags */
</script>

<section class="bg-tertiary relative z-10 mx-auto w-full max-w-[120rem] lg:mb-44 lg:h-[61.25rem]">
	<div
		class="container flex flex-col-reverse items-center justify-between lg:mt-0 lg:h-full lg:flex-row lg:items-stretch lg:gap-10"
	>
		<div
			class="-mt-10 self-center bg-white px-4 py-8 lg:mt-0 lg:max-w-[35rem] lg:bg-transparent lg:px-12 lg:py-0 xl:max-w-[49.125rem]"
		>
			<h2 use:flyInOnScroll class="text-xl font-semibold leading-[1.13] sm:text-xl md:text-2xl lg:mb-12 xl:text-4xl">
				{nbspify(headline)}
			</h2>
			<p use:flyInOnScroll class="mt-6 text-base font-light min-[425px]:text-[1.125rem]">
				{@html nbspifyHtml(description)}
			</p>
		</div>
		<StaticPicture
			image={juricekBanner}
			alt={ceoName}
			width={1920}
			height={1080}
			imgClass="w-full object-contain lg:absolute bottom-0 max-sm:h-[24.25rem] max-sm:w-[24.25rem]"
			class="bg-tertiary -z-10 aspect-square lg:absolute lg:bottom-0 lg:right-0 lg:w-[58rem]"
		/>
	</div>
	<div class="container py-16 lg:py-24">
		<div class="flex flex-col lg:flex-row-reverse lg:gap-52">
			<span class="mb-4 shrink-0 text-lg font-bold lg:mr-24">{nbspify(ceoName)}</span>
			<div class={isSmall ? "text-2md" : "text-lg"}>
				{@html nbspifyHtml(about)}
			</div>
		</div>
	</div>
</section>
